import { ChevronDown, ChevronUp, BellOff } from "lucide-react";
import { formatLastMessage, chatRowClasses } from "./chatUtils";

const ChatDmList = ({
  dms,
  expanded,
  currentTeamId,
  unreadCounts,
  mutedConversations,
  onlineUsers,
  onToggle,
  onSelect,
}) => {
  if (dms.length === 0) return null;

  return (
    <>
      <button
        onClick={() => onToggle("dms")}
        className="w-full flex items-center gap-x-1.5 px-2 py-1 text-[10px] uppercase tracking-wider text-zinc-400 dark:text-zinc-600 hover:text-zinc-500 dark:hover:text-zinc-500 transition-colors mt-1"
      >
        <span className="flex-1 text-left">Direct Messages</span>
        {!expanded &&
          (() => {
            const total = dms.reduce(
              (sum, d) => sum + (unreadCounts[d.team_id] || 0),
              0,
            );
            return total > 0 ? (
              <span className="text-sky-500 text-[10px] font-medium">
                {total > 99 ? "99+" : total}
              </span>
            ) : null;
          })()}
        {expanded ? (
          <ChevronUp className="h-2.5 w-2.5 shrink-0" strokeWidth={2} />
        ) : (
          <ChevronDown className="h-2.5 w-2.5 shrink-0" strokeWidth={2} />
        )}
      </button>
      {expanded &&
        dms.map((dm) => {
          const isActive = dm.team_id === currentTeamId;
          const displayName = dm.dm_display_name || "Unknown";
          const initial = (displayName[0] || "?").toUpperCase();
          const isOnline = onlineUsers.has(dm.dm_user_uuid);
          const unread = unreadCounts[dm.team_id] || 0;
          return (
            <div
              key={dm.team_id}
              data-context-menu="team-conversation"
              data-context-payload={JSON.stringify({
                team_id: dm.team_id,
                type: "dm",
                name: dm.dm_display_name,
              })}
            >
              <button
                onClick={() => onSelect(dm.team_id)}
                title={displayName}
                className={chatRowClasses(isActive)}
              >
                <span className="relative w-4 h-4 shrink-0">
                  <span className="w-4 h-4 rounded-full bg-zinc-300 dark:bg-zinc-700 flex items-center justify-center text-[9px] font-medium text-white">
                    {initial}
                  </span>
                  {isOnline && (
                    <span className="absolute -bottom-0.5 -right-0.5 w-2 h-2 bg-green-500 rounded-full border border-white dark:border-zinc-900" />
                  )}
                </span>
                <span className="truncate">{displayName}</span>
                {unread > 0 ? (
                  <span className="ml-auto bg-sky-500 text-white text-[10px] font-medium rounded-full min-w-[18px] h-[18px] flex items-center justify-center px-1 shrink-0">
                    {unread > 99 ? "99+" : unread}
                  </span>
                ) : (
                  <span className="ml-auto flex items-center gap-x-1 shrink-0">
                    {mutedConversations.includes(dm.team_id) && (
                      <BellOff
                        className="h-3 w-3 text-zinc-300 dark:text-zinc-600"
                        strokeWidth={2}
                      />
                    )}
                    <span className="text-[10px] text-zinc-400 dark:text-zinc-600">
                      {isOnline
                        ? "online"
                        : dm.last_message_ts
                          ? formatLastMessage(dm.last_message_ts)
                          : ""}
                    </span>
                  </span>
                )}
              </button>
            </div>
          );
        })}
    </>
  );
};

export default ChatDmList;
